import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';

import { apiMutation } from 'app/utils/request/api';

const path = 'admin/bills/:billId/relaunch-payout';

export function useRelaunchPayout() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      billId,
      payoutId,
    }: {
      billId: number;
      payoutId?: number;
    }) =>
      apiMutation(
        'POST',
        { path, params: { billId: billId.toString() } },
        { payoutId }
      ) as Promise<string>,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['/admin/bills'] });
      message.success('Payout retried successfully');
    },
    onError: () => {
      message.error('Error while retrying payout');
    },
  });
}
